<div class="user-monogram {{ compact ? 'compact' : '' }}" *ngIf="userName && userName != ''">
    <div class="user-monogram-cell" [style.backgroundColor]="colour" [title]="userName">
        <span class="noselect" [style.color]="textColour">{{ monogram }}</span>
    </div>
</div>
